import { useControlledSearchInput } from '@deltasierra/react-hooks';
import * as React from 'react';
import { DSTextField } from '../../mui/TextField';
import { PickableClientGroup } from './PickableClientGroup';
import { BasicLocationPickerClientGroup } from './types';

export type BasicLocationPickerProps = {
    clients: ReadonlyArray<BasicLocationPickerClientGroup>;
    selected: ReadonlyArray<string>;
    disabled?: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const BasicLocationPicker: React.FC<BasicLocationPickerProps> = ({
    clients,
    disabled = [],
    onChange,
    selected,
}) => {
    const { inputProps, searchTerm } = useControlledSearchInput({
        initialValue: '',
        interval: 250,
    });

    const filteredItems = React.useMemo(
        () =>
            clients
                .reduce<BasicLocationPickerClientGroup[]>((carry, current) => {
                    if (current.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        return [...carry, current];
                    } else {
                        const filtered = current.items.filter(
                            item => item.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
                        );
                        return [
                            ...carry,
                            {
                                ...current,
                                items: filtered,
                            },
                        ];
                    }
                }, [])
                .filter(client => client.items.length > 0),
        [clients, searchTerm],
    );

    return (
        <>
            <DSTextField fullWidth label="Search" variant="outlined" {...inputProps} />
            {filteredItems.map(client => (
                <PickableClientGroup
                    client={client}
                    disabled={disabled}
                    key={client.id}
                    selected={selected}
                    onChange={onChange}
                />
            ))}
        </>
    );
};

BasicLocationPicker.displayName = 'BasicLocationPicker';
